import React, { useEffect, useState } from 'react';
import { Routes, Route, Outlet, Link, Navigate, useLocation } from "react-router-dom";


import MainLayout from './pages/mainLayout';
import AdminLayout from './pages/adminLayout';

import Home from "./pages/home";
import About from "./pages/about";
import Login from "./pages/login";
import Register from "./pages/register";
import NotFound from "./pages/notfound";
import MyInfo from './pages/myInfo';
import EnrollUser from './pages/enrollUser';
import EnrollCourse from './pages/enrolCourse';
import RequestCourseList from './pages/requestCourseList';
import AdminPage from './pages/adminPage';



import UserList from './pages/userList';
import UserInfo from './pages/userInfo';

import RegisterBooking from './pages/registerBooking';


import { useBookContext } from "./contexts/bookContext";
import { ThemeProvider, createTheme, } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
const theme = createTheme({
  colorSchemes: {
    dark: true,
  },
  cssVariables: {
    colorSchemeSelector: 'data'
  }
});


function App() {

  const { userData,  isLogin, actions } = useBookContext();
  const [init, setInit] = useState(true);
  const location = useLocation();
  const pathname = location.pathname;

  console.log("main locatin :"+JSON.stringify(location))

  useEffect(() => {
  }, [init]);



  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline  /> 
        <Routes>
          {/* 
        Routes안에 이렇게 작성합니다. 
        Route에는 react-router-dom에서 지원하는 props들이 있습니다.

        path는 우리가 흔히 말하는 사용하고싶은 "주소"를 넣어주면 됩니다.
        element는 해당 주소로 이동했을 때 보여주고자 하는 컴포넌트를 넣어줍니다.
      */}
          <Route path="/" exact element={<MainLayout />} >
            <Route index element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="myinfo" element={<MyInfo />} />
            <Route path="enrolluser" element={<EnrollUser />} />
            <Route path="enrollcourse" element={<EnrollCourse />} />
            <Route path="adminPage" element={<AdminPage />} />
            <Route path="requestCourseList" element={<RequestCourseList />} />
            <Route path="registerBooking" element={<RegisterBooking />} />
          </Route>
          <Route path="Admin" exact element={<AdminLayout />} >
            <Route index element={<UserList />} />
            <Route path="userList" element={<UserList />} />
            <Route path="enrolluser" element={<EnrollUser />} />
            <Route path="enrollcourse" element={<EnrollCourse />} />
            <Route path="requestCourseList" element={<RequestCourseList />} />
          </Route>
          <Route path="userInfo" element={<UserInfo />} />
          <Route path="about" element={<About />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

      </ThemeProvider>

    </>
  );
}
export default App;
